if (!customElements.get('dear-v-quiz')) {
  customElements.define('dear-v-quiz', class extends HTMLElement {
    connectedCallback() {
      queueMicrotask(() => {
        if (!this.isConnected) return;
        this.controller?.abort();
        this.controller = new AbortController();
        const { signal } = this.controller;
        this.screens = Array.from(this.querySelectorAll('[data-quiz-screen]'));
        this.progress = this.querySelector('[data-quiz-progress]');
        this.progressFill = this.querySelector('[data-quiz-progress-fill]');
        this.restart = this.querySelector('[data-quiz-restart]');
        this.dialog = this.closest('dialog');
        this.reset(false);
        this.addEventListener('click', (event) => {
          if (!(event.target instanceof Element)) return;
          const button = event.target.closest('button');
          if (button?.matches('[data-quiz-start]')) this.show('0');
          if (button?.matches('[data-quiz-restart]')) this.reset(true);
          if (button?.matches('[data-quiz-answer]')) this.answer(button);
          const pack = event.target.closest('[data-quiz-pack]');
          if (pack) this.selectPack(pack, event);
        }, { signal });
        this.addEventListener('keydown', (event) => {
          if (!['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key)) return;
          if (!(event.target instanceof Element) || !event.target.matches('[data-quiz-answer]')) return;
          const buttons = Array.from(event.target.parentElement.querySelectorAll('[data-quiz-answer]'));
          if (buttons.some((button) => button.disabled)) return;
          const current = buttons.indexOf(event.target);
          const index = event.key === 'Home' ? 0 : event.key === 'End' ? buttons.length - 1 : (current + (event.key === 'ArrowDown' ? 1 : -1) + buttons.length) % buttons.length;
          event.preventDefault();
          buttons[index].focus();
        }, { signal });
        this.dialog?.addEventListener('close', () => this.reset(false), { signal });
        if (window.Shopify?.designMode && this.dialog) {
          document.addEventListener('shopify:section:select', (event) => {
            if (!event.target.contains(this) || this.dialog.open) return;
            this.dialog.dearVReturnFocus = document.activeElement;
            this.dialog.showModal();
          }, { signal });
          document.addEventListener('shopify:section:deselect', (event) => {
            if (event.target.contains(this) && this.dialog.open) this.dialog.close();
          }, { signal });
        }
      });
    }

    disconnectedCallback() {
      this.controller?.abort();
      clearTimeout(this.timer);
    }

    reset(focus) {
      clearTimeout(this.timer);
      this.answers = [];
      this.busy = false;
      this.removeAttribute('aria-busy');
      delete this.dataset.transitioning;
      delete this.dataset.result;
      this.querySelectorAll('[data-quiz-answer]').forEach((button) => {
        button.disabled = false;
        button.setAttribute('aria-pressed', 'false');
      });
      this.show('intro', focus);
    }

    show(step, focus = true) {
      this.dataset.step = step;
      this.screens.forEach((screen) => { screen.hidden = screen.dataset.quizScreen !== step; });
      const current = this.screens.find((screen) => screen.dataset.quizScreen === step);
      const question = ['0', '1', '2'].includes(step);
      this.progress.hidden = !question;
      this.progressFill.style.width = question ? `${(Number(step) + 1) / 3 * 100}%` : '0%';
      this.restart.hidden = step === 'intro';
      if (focus) {
        current?.querySelector('[data-quiz-heading]')?.focus({ preventScroll: Boolean(this.dialog) });
        if (this.dialog) this.dialog.scrollTop = 0;
      }
    }

    answer(button) {
      if (this.busy || !['0', '1', '2'].includes(this.dataset.step) || button.closest('[data-quiz-screen]').hidden) return;
      const choice = button.dataset.quizAnswer;
      if (!['A', 'B'].includes(choice)) return;
      this.busy = true;
      this.answers.push(choice);
      button.setAttribute('aria-pressed', 'true');
      button.parentElement.querySelectorAll('button').forEach((answer) => { answer.disabled = true; });
      this.dataset.transitioning = 'true';
      const delay = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 250;
      this.timer = window.setTimeout(() => {
        delete this.dataset.transitioning;
        if (this.answers.length < 3) {
          this.busy = false;
          this.show(String(this.answers.length));
          return;
        }
        this.setAttribute('aria-busy', 'true');
        this.show('loading');
        this.timer = window.setTimeout(() => {
          const winner = this.answers.filter((answer) => answer === 'A').length >= 2 ? 'A' : 'B';
          this.busy = false;
          this.removeAttribute('aria-busy');
          this.dataset.result = winner;
          this.show(winner);
          this.dispatchEvent(new CustomEvent('dear-v:quiz-complete', { bubbles: true, detail: { result: winner } }));
        }, 800);
      }, delay);
    }

    selectPack(link, event) {
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || link.target === '_blank') return;
      const url = new URL(link.href, location.href);
      if (url.origin !== location.origin || url.pathname !== location.pathname || url.searchParams.get('view') !== new URL(location.href).searchParams.get('view')) return;
      const product = document.querySelector('mte-product-component');
      if (!product) return;
      product.dispatchEvent(new CustomEvent('dear-v:select-pack', { detail: { pack: '3' } }));
      const destination = new URL(location.href);
      destination.searchParams.set('pack', '3');
      destination.hash = url.hash;
      history.replaceState(null, '', destination);
      if (this.dialog?.open) this.dialog.close();
    }
  });
}
